var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCampaign(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 254,
    height: 223,
    viewBox: "0 0 254 223",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7998 111.305C15.7998 140.798 27.5155 169.082 48.3695 189.936C69.2236 210.79 97.5077 222.505 127 222.505C156.492 222.505 184.776 210.79 205.63 189.936C226.484 169.082 238.2 140.798 238.2 111.305C238.2 81.8134 226.484 53.5292 205.63 32.6752C184.776 11.8211 156.492 0.105469 127 0.105469C97.5077 0.105469 69.2236 11.8211 48.3695 32.6752C27.5155 53.5292 15.7998 81.8134 15.7998 111.305Z",
    fill: "#F2F2F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M232.404 146.75H21.5962C29.0176 168.827 43.1834 188.016 62.095 201.61C81.0066 215.204 103.709 222.517 127 222.517C150.29 222.517 172.993 215.204 191.905 201.61C210.816 188.016 224.982 168.827 232.404 146.75Z",
    fill: "#D9CC85"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M124.457 185.39L129.544 189.001",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M151.487 169.219L145.262 169.588",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.6875 181.111L94.1514 175.974",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M53.9253 174.072L54.106 167.837",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M170.946 194.917L177.104 195.909",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M108.561 211.536L111.249 205.906",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M147.269 200.313L152.985 197.822",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M74.4668 195.267L77.1523 189.638",
    stroke: "#0D0D0D",
    strokeWidth: 5.56,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M245.15 146.703H252.1",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M1.8999 146.703H8.8499",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M239.59 146.759H14.4097",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M152.456 83.4941C152.456 83.4941 148.186 102.598 157.58 112.781C162.742 118.378 171.908 118.594 175.547 108.52C185.88 105.701 186.567 94.1999 179.978 90.3858C172.614 86.1212 164.56 93.9052 152.456 83.4941Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M213.027 95.4209C213.027 95.4209 217.956 110.366 211.245 119.259C207.556 124.144 200.245 125.045 196.533 117.272C188.04 115.834 186.581 106.688 191.552 103.116C197.106 99.1183 204.167 104.709 213.027 95.4209Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M119.135 118.859C118.801 117.142 119.081 115.363 119.926 113.832C120.771 112.3 122.128 111.115 123.759 110.483C129.135 108.184 137.747 110.897 141.331 109.371C144.914 107.845 132.724 126.643 119.135 118.859Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M114.653 134.691C114.285 132.981 113.328 131.455 111.949 130.38C110.57 129.304 108.856 128.748 107.108 128.808C101.27 128.808 94.4094 134.691 90.5118 134.691C86.6143 134.691 105.224 147.192 114.653 134.691Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M119.03 148.68C107.354 129.364 123.267 127.646 119.25 118.934",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M46.8241 133.724C47.1305 135.037 48.1819 136.119 49.747 136.732C51.3121 137.345 53.2627 137.44 55.1697 136.995C57.0767 136.549 58.7839 135.601 59.9157 134.358C61.0475 133.115 61.5113 131.68 61.2049 130.367C60.8985 129.055 59.8471 127.973 58.282 127.36C56.7169 126.746 54.7663 126.652 52.8593 127.097C50.9523 127.542 49.2451 128.49 48.1133 129.733C46.9815 130.976 46.5177 132.412 46.8241 133.724Z",
    fill: "white",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M61.2056 130.371C63.4422 134.727 64.3563 139.642 63.8354 144.51C63.8354 144.51 61.3112 152.711 63.513 157.982",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M109.903 167.247C118.919 157.965 111.485 153.611 119.03 148.68C128.438 152.074 119.519 162.152 130.428 164.003",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M187.935 130.227V154.507",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M187.935 154.507C174.382 157.965 181.188 171.743 173.843 175.123",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M179.42 161.763C178.09 163.364 176.447 164.676 174.591 165.619C172.736 166.561 170.707 167.115 168.63 167.245",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M187.935 154.507C201.487 157.965 196.355 168.752 203.7 172.14",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M198.135 163.322C196.568 165.258 195.713 167.673 195.713 170.164C195.713 172.655 196.568 175.07 198.135 177.005",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M187.935 154.507C187.935 154.507 184.935 161.457 187.54 166.842C190.145 172.227 187.935 181.175 187.935 181.175",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.605 170.575C186.923 173.218 184.497 175.305 181.632 176.572",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M206.046 107.936C195.135 115.52 187.935 130.226 187.935 130.226C187.935 130.226 183.345 106.507 162.753 98.998",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2812 24.6393V19.6631",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1646 33.3849L61.6479 29.8682",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M56.4181 54.502H51.4419",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M65.1646 75.6182L61.6479 79.1377",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M109.058 33.3849L112.574 29.8682",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M117.804 54.502H122.78",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M109.058 75.6182L112.574 79.1377",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M86.2812 84.3643V89.3405",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M63.0547 54.5013C63.0547 57.5515 63.6555 60.5718 64.8227 63.3899C65.99 66.2079 67.7009 68.7684 69.8577 70.9252C72.0145 73.082 74.575 74.7929 77.393 75.9602C80.2111 77.1274 83.2314 77.7282 86.2816 77.7282C89.3318 77.7282 92.3521 77.1274 95.1701 75.9602C97.9882 74.7929 100.549 73.082 102.705 70.9252C104.862 68.7684 106.573 66.2079 107.74 63.3899C108.908 60.5718 109.508 57.5515 109.508 54.5013C109.508 51.4511 108.908 48.4308 107.74 45.6128C106.573 42.7947 104.862 40.2342 102.705 38.0774C100.549 35.9206 97.9882 34.2097 95.1701 33.0425C92.3521 31.8752 89.3318 31.2744 86.2816 31.2744C83.2314 31.2744 80.2111 31.8752 77.393 33.0425C74.575 34.2097 72.0145 35.9206 69.8577 38.0774C67.7009 40.2342 65.99 42.7947 64.8227 45.6128C63.6555 48.4308 63.0547 51.4511 63.0547 54.5013Z",
    fill: "#FFE137",
    stroke: "#0D0D0D",
    strokeWidth: 2.78,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCampaign);
export default __webpack_public_path__ + "static/media/campaign.6661aea00b7089ebecc5d40fc9ab00d6.svg";
export { ForwardRef as ReactComponent };